import PropTypes from 'prop-types';
import { useRef, useEffect } from 'react';

// shadcn
import { Textarea } from 'src/@/components/ui/textarea';
import { Button } from 'src/@/components/ui/button';

//
import Iconify from 'src/components/Iconify';

// ----------------------------------------------------------------------

DrawerChatgptInput.propTypes = {
  disabled: PropTypes.bool,
  conversationId: PropTypes.string,
  onSend: PropTypes.func
};

export default function DrawerChatgptInput({ disabled, loadingGpt, changeText, text, conversationId, onSend, onOpenMenu, ...other }) {
  const textareaRef = useRef(null);

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      if (text && text.trim() && !loadingGpt) {
        onSend();
      }
    }
  };

  // Auto-resize textarea
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [text]);

  const hasText = text && text.trim().length > 0;

  return (
    <div 
      className="w-full rounded-xl border border-gray-200 bg-white shadow-sm transition-all duration-200 hover:border-gray-300 focus-within:border-primary focus-within:ring-2 focus-within:ring-primary/10"
      {...other}
    >
      <div className="relative flex items-end gap-2 p-3">
        {/* Textarea Container */}
        <div className="flex-1 relative">
          <Textarea
            ref={textareaRef}
            value={!loadingGpt ? text : "Gerando resposta..."}
            disabled={loadingGpt || disabled}
            onKeyDown={handleKeyDown}
            onChange={changeText}
            placeholder={loadingGpt ? "Gerando resposta..." : "Escreva uma mensagem..."}
            className="min-h-[44px] max-h-[200px] resize-none border-0 bg-transparent p-0 pr-10 text-sm leading-6 placeholder:text-gray-400 focus-visible:ring-0 focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-60"
            rows={1}
          />
          
          {/* Character count or loading indicator */}
          {loadingGpt && (
            <div className="absolute bottom-1 right-2 flex items-center gap-1.5 text-xs text-gray-400">
              <div className="h-1.5 w-1.5 animate-pulse rounded-full bg-primary"></div>
              <span>Processando...</span>
            </div>
          )}
        </div>

        {/* Send Button */}
        <Button 
          variant={hasText && !loadingGpt ? "default" : "ghost"}
          size="icon"
          disabled={!hasText || loadingGpt || disabled}
          onClick={onSend}
          className={`h-10 w-10 shrink-0 rounded-lg transition-all duration-200 ${
            hasText && !loadingGpt 
              ? "bg-primary text-white hover:bg-primary/90 shadow-sm" 
              : "text-gray-400 hover:text-gray-600 hover:bg-gray-100"
          } disabled:opacity-40 disabled:cursor-not-allowed`}
        >
          {loadingGpt ? (
            <Iconify width={18} icon="svg-spinners:3-dots-fade" className="animate-spin" />
          ) : (
            <Iconify width={20} icon="mdi:send" />
          )}
        </Button>
      </div>

      {/* Footer with helper text */}
      <div className="flex items-center justify-between border-t border-gray-100 px-3 py-2">
        <div className="flex items-center gap-2 text-xs text-gray-400">
          <span>Pressione Enter para enviar</span>
          <span className="text-gray-300">•</span>
          <span>Shift + Enter para nova linha</span>
        </div>
      </div>
    </div>
  );
}
